import { animate, createTimeline } from 'animejs';

const revealPerson = (text, image, selected, onComplete) => {
  // 1. Split targets from params
  animate(document.querySelector('.largePerson'), {
    ease: 'linear',
    translateX: [30, 0],
    duration: 1000,
    onComplete: () => {
      onComplete?.();
    },
  });

  // 2. Use refs safely with argument splitting
  const selectedImg = image.current?.querySelector(`[data-id*="${selected.id}"]`);
  if (selectedImg) {
    animate(selectedImg, {
      ease: 'linear',
      duration: 1000,
      opacity: [0, 1],
    });
  }

  if (text.current) {
    animate(text.current, {
      ease: 'linear',
      duration: 1000,
      opacity: [0, 1],
      translateX: [-30, 0],
      delay: 400,
    });
  }
};

const hidePerson = (text, image, selected, onComplete) => {
  const selectedImg = image.current?.querySelector(`[data-id*="${selected.id}"]`);

  // v4 Timelines: createTimeline(params).add(target, params, position)
  createTimeline({
    defaults: {
      ease: 'linear',
      duration: 500,
    },
    onComplete: () => {
      onComplete?.();
    },
  })
    .add(
      text.current,
      {
        opacity: [1, 0],
      },
      0,
    ) // Target is 1st arg, Params 2nd, Position 3rd
    .add(
      selectedImg,
      {
        opacity: [1, 0],
      },
      0,
    );
};

export { revealPerson, hidePerson };
